import { useEffect, useState } from "react";
import { useFilterContext } from '../components/FilterContext';
import { useResetContext} from '../components/ResetContext';

const useGraphRadio = () => {

  const [radio_data,set_radio_data] = useState(null);
  const { filterdata, updateFilterData } = useFilterContext();
  const {resetdata, updateresetdata} = useResetContext();

  console.log("filterdata", filterdata);


  const RadioQuery = async ({ vins_short, radio_value, columnname, category, startDate, endDate }) => {
    console.log("vin_shortecec", vins_short, radio_value, columnname, category, startDate, endDate, filterdata);
  
    try {
      let baseURL;
      if (window.location.hostname === "simbaanalytics-dev.rio.cloud") {
        baseURL = "https://26ovsbph5oz6xpn2fgscmr5x5i0socao.lambda-url.eu-west-1.on.aws";
      } else if (window.location.hostname === "bev-dev.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://spv3toxlwj.execute-api.eu-west-1.amazonaws.com/test_cognito";
      } else if (window.location.hostname === "bev-prod.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://dnz0zln7l2.execute-api.eu-west-1.amazonaws.com/prod";
      } else {
        baseURL = "http://localhost:8080";
      }
  
      const token = localStorage.getItem("idToken");
  
      if (!token) {
        console.error("No ID token found! User might not be authenticated.");
        return;
      }
  
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
  
      // Include filterdata in the request body if needed
      const response = await fetch(`${baseURL}/radio-dropdown-graph`, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ vins_short, radio_value, columnname, category, startDate, endDate, filterdata,resetdata }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const jsonData = await response.json();
      return { jsonData };
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  // //console.log('graph_dataefef',radio_data);

  return RadioQuery;
};

export default useGraphRadio;
